import React from 'react'

function Info() {
  return (
    <div className="info">
       <p> Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">Frontend Mentor</a>. 
        Coded by <a href="https://anuoluwaoyetibo-1ba4e.web.app/" target="_blank" rel="noreferrer">Anuoluwapo Oyetibo</a>.</p>
        <p>Designed by O.A.G_STUDIOS. &copy; 2022</p>
    </div>
  )
}

export default Info